import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import useIdleTimer from '../hooks/useIdleTimer'
import InstructionImage from '../assets/images/instructions.png'

const Instruction = () => {
  const navigate = useNavigate()

  const { t } = useTranslation()

  useIdleTimer()

  return (
    <div className="text-[60px] text-left w-[620px] h-[1060px] mx-auto mt-[210px]">
      <div className="flex flex-col w-[640px] mx-auto items-start justify-center">

        <h1 className="text-[66px] text-white uppercase font-euclid-circular-b-bold mt-[20px] mb-[20px]">{t('howToPlay')}</h1>
        <p className="text-white leading-[1.2] text-[48px] font-euclid-circular-b-regular">{t('howToPlayDescription')}</p>
        <img src={InstructionImage} alt="Instruction" className="w-[350px] mx-auto mt-[10px]" />
        <button
          type="button"
          className="bg-[#ffab54] absolute bottom-[210px] left-[235px] w-[379px] h-[93px] flex items-center justify-center cursor-pointer rounded-[10px] disabled:opacity-50 disabled:cursor-not-allowed"
          onClick={() => navigate('/game')}
        >
          <span className="relative z-10 text-[#000b48] text-[48px] font-euclid-circular-b-semibold">{t('start')}</span>
        </button>
      </div>
    </div>
  )
}

export default Instruction
